<template>
  <CustomBlipLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import CustomBlipLineChart from '@/components/cards/models/CustomBlipLineChart';
import { mapActions } from 'vuex';
import colors from '@/utils/colors';
import { setDateToUTC } from '@/utils/date';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipMessageVolumeInPeriod',
  components: {
    CustomBlipLineChart,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      default: 'D',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      dataLabel: [
        this.$t('components.BlipMessageVolumeInPeriod.label.series.receivedMessages'),
        this.$t('components.BlipMessageVolumeInPeriod.label.series.sentMessages'),
      ],
    };
  },
  computed: {
    cardOptions() {
      return {
        chart: {
          type: 'spline',
        },
        legend: {
          enabled: true,
        },
        yAxis: {
          gridLineWidth: 0.5,
          tickLength: 0,
        },
      };
    },
    series() {
      if (!this.rawSeries && !this.rawSeries.length) {
        return [];
      }
      return this.rawSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      this.rawSeries = [];

      this.getBlipService({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then((response) => {
          const receivedMessagesResponse = this.aggregateData(response, 0);
          const sentMessagesResponse = this.aggregateData(response, 1);

          const receivedMessagesData = {
            name: this.$t('components.BlipMessageVolumeInPeriod.label.series.receivedMessages'),
            color: colors.componentsColor.seriesBrandPure,
            data: Object.keys(receivedMessagesResponse).map(date => ({
              x: setDateToUTC(date).getTime(),
              y: receivedMessagesResponse[date],
            })),
            marker: {
              symbol: 'circle',
            },
          };

          const sentMessagesData = {
            name: this.$t('components.BlipMessageVolumeInPeriod.label.series.sentMessages'),
            color: colors.componentsColor.seriesYellow56,
            data: Object.keys(sentMessagesResponse).map(date => ({
              x: setDateToUTC(date).getTime(),
              y: sentMessagesResponse[date],
            })),
            marker: {
              symbol: 'circle',
            },
          };

          this.rawSeries = [
            receivedMessagesData,
            sentMessagesData,
          ];
          this.requestStatus = 'success';
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>
